// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckboxListController from "./checkbox_list_controller"
application.register("checkbox-list", CheckboxListController)

import ConversationController from "./conversation_controller"
application.register("conversation", ConversationController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import PlacesController from "./places_controller"
application.register("places", PlacesController)

import RemoveElementController from "./remove_element_controller"
application.register("remove-element", RemoveElementController)

// import SearchController from "./search_controller"
// application.register("search", SearchController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)
